import React from "react";
import explore from "../../assets/explore.png";
import Vector1 from "../../assets/products/Vector1.png";
import Nail from "../../assets/products/Nail.png";
import "../../styles/products.css";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
const { Search } = Input;

const MainProducts = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const onSearch = (value, _e, info) => console.log(info?.source, value);

  return (
    <div className={`relative px-20 max-lg:px-5 store ${language == "ar" && "store_ar"}`}>
      <div className="text-center">
        <h2 className="text-[#14294F] text-4xl max-lg:text-2xl font-bold mt-16 leading-relaxed lg:w-[700px] text-center mx-auto">
          {t("mainProducts.title")}
        </h2>
        <img
          src={Vector1}
          alt="Vector"
          className={`absolute left-24 ${language == "en" ? "top-14" : "-top-8"} w-[540px] h-[340px] max-lg:hidden`}
        />
        <p className="text-[#737E91] text-2xl mt-5 w-1/2 max-lg:w-full mx-auto">
          {t("mainProducts.description")}
        </p>

        <img
          src={Nail}
          alt="Nail"
          className={`absolute  left-1/2 ${language == "en" ? "top-40 w-[230px] h-[140px]" : "top-28 w-[150px] h-[100px]"} max-lg:top-44 max-lg:w-[150px] max-lg:h-[120px] z-0`}
        />
        <Search
          placeholder={t("mainProducts.searchPlaceholder")}
          onSearch={onSearch}
          className="text-[#FE9B71] w-[380px] max-lg:w-full h-[55px] mt-24 max-lg:mt-20 relative z-10 text-xl flex items-center justify-between mx-auto"
        />
      </div>
    </div>
  );
};

export default MainProducts;